module.exports = __webpack_public_path__ + "assets/img/call-icon.6436ba93.svg";